/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { eocFetch as fetch } from '@atlassian/eoc-fetch/controllers';

export const updateStarredSavedSearch = (savedSearchId = ''): Promise<string[]> =>
	fetch<Array<string>>('/v1/alerts/ui-preferences/starredSearches', {
		method: 'POST',
		body: {
			id: savedSearchId,
		},
	});

export const deleteStarredSavedSearch = (savedSearchId = ''): Promise<string> =>
	fetch(`/v1/alerts/ui-preferences/starredSearches?savedSearchId=${savedSearchId}`, {
		method: 'DELETE',
		responseType: 'text',
	});
